var _a, _b, _c, _d, _e, _f, _g, _h;
import { Brand } from './Brand';
export var InteractionType;
(function (InteractionType) {
    InteractionType["Phone"] = "Phone";
    InteractionType["FaceToFace"] = "F2F";
    InteractionType["Video"] = "Video";
    InteractionType["Store"] = "Store";
})(InteractionType || (InteractionType = {}));
export var AppointmentLengthType;
(function (AppointmentLengthType) {
    AppointmentLengthType["15_30_15"] = "15_30_15";
    AppointmentLengthType["15_60_15"] = "15_60_15";
    AppointmentLengthType["60_60_60"] = "60_60_60";
})(AppointmentLengthType || (AppointmentLengthType = {}));
export var AppointmentLength = {
    '15_30_15': {
        preBuffer: 15,
        length: 30,
        postBuffer: 15,
    },
    '15_60_15': {
        preBuffer: 15,
        length: 60,
        postBuffer: 15,
    },
    '60_60_60': {
        preBuffer: 60,
        length: 60,
        postBuffer: 60,
    },
};
export var BrandInteractionType = (_a = {},
    _a[Brand.Lendi] = (_b = {},
        _b[InteractionType.Phone] = AppointmentLengthType['15_30_15'],
        _b[InteractionType.Video] = AppointmentLengthType['15_30_15'],
        _b[InteractionType.FaceToFace] = AppointmentLengthType['15_30_15'],
        _b),
    _a[Brand.Domain] = (_c = {},
        _c[InteractionType.Phone] = AppointmentLengthType['15_30_15'],
        _c[InteractionType.Video] = AppointmentLengthType['15_30_15'],
        _c[InteractionType.FaceToFace] = AppointmentLengthType['15_30_15'],
        _c),
    _a[Brand.Aussie] = (_d = {},
        _d[InteractionType.Phone] = AppointmentLengthType['15_30_15'],
        _d[InteractionType.Video] = AppointmentLengthType['15_30_15'],
        _d[InteractionType.FaceToFace] = AppointmentLengthType['60_60_60'],
        _d[InteractionType.Store] = AppointmentLengthType['15_60_15'],
        _d),
    _a);
export var AppointmentLeadTimeMinutes = (_e = {},
    _e[Brand.Lendi] = (_f = {},
        _f[InteractionType.Phone] = 60,
        _f[InteractionType.Video] = 60,
        _f),
    _e[Brand.Domain] = (_g = {},
        _g[InteractionType.Phone] = 60,
        _g[InteractionType.Video] = 60,
        _g),
    _e[Brand.Aussie] = (_h = {},
        _h[InteractionType.Phone] = 120,
        _h[InteractionType.Video] = 120,
        _h[InteractionType.FaceToFace] = 240,
        _h[InteractionType.Store] = 240,
        _h),
    _e);
//# sourceMappingURL=AppointmentLength.js.map